import React from 'react';

export default function ChordBar({ activeChords, currentChord, onSelectChord, onOpenSettings }) {
  const isMany = activeChords.length > 5;
  
  return (
    <div id="chord-bar" className={isMany ? "many-chords" : ""}>
      {activeChords.map((chord, idx) => (
        <button
          key={`${chord}-${idx}`}
          className={`chord-btn ${chord === currentChord ? 'active' : ''}`}
          style={{ fontSize: chord.length > 3 ? '0.8rem' : null }}
          onTouchStart={(e) => { e.preventDefault(); onSelectChord(chord); }} // Using touch start for instant response
          onMouseDown={(e) => { e.preventDefault(); onSelectChord(chord); }}
        >
          {chord}
        </button>
      ))}
      <button className="chord-btn add-btn" onClick={onOpenSettings}>+</button>
    </div>
  );
}
